import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleSheetsRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 31 31",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#009954",
			d: "m3 13.2.1-2.4a3 3 0 0 1 1.6-1.6Q5.3 9 7 9h8.5q1.8 0 2.4.2a3 3 0 0 1 1.6 1.6l.1 2.4v6l-.1 2.3a3 3 0 0 1-1.6 1.6q-.6.3-2.4.2H7.1q-1.9 0-2.4-.2A3 3 0 0 1 3 21.5q-.3-.6-.2-2.3z"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "google-sheets-regular-mask",
			width: 23,
			height: 19,
			x: 5,
			y: 6,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "luminance" },
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M25 6.5H8a3 3 0 0 0-2.8 2.8v12.5A3 3 0 0 0 8 24.6h17a3 3 0 0 0 2.8-2.8V9.3A3 3 0 0 0 25 6.5"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#google-sheets-regular-mask)",
			children: [/* @__PURE__ */ _jsx("path", {
				fill: "#0ebc5f",
				d: "M3.1 5.9H29v20.6H3z"
			}), /* @__PURE__ */ _jsx("g", {
				filter: "url(#google-sheets-regular-filter)",
				children: /* @__PURE__ */ _jsx("path", {
					fill: "url(#google-sheets-regular-gradient)",
					d: "M21.3 24h-15a4 4 0 0 1-4-4.1v-8.2a4 4 0 0 1 4-4.1h15a4 4 0 0 1 4.1 4V20a4 4 0 0 1-4 4"
				})
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#fff",
			strokeLinecap: "round",
			strokeWidth: 1.68,
			d: "M12.6 19h11.8m-2.8 2.6v-9"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "google-sheets-regular-gradient",
			x1: 21.928,
			y1: 17.016,
			x2: 5.595,
			y2: 17.016,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0ebc5f" }), /* @__PURE__ */ _jsx("stop", {
				offset: .95,
				stopColor: "#78c9ff"
			})]
		}), /* @__PURE__ */ _jsxs("filter", {
			id: "google-sheets-regular-filter",
			width: 27.66,
			height: 20.9,
			x: .01,
			y: 5.33,
			colorInterpolationFilters: "sRGB",
			filterUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					result: "effect1_foregroundBlur_14623_767",
					stdDeviation: 1.12
				})
			]
		})] })
	]
});
export default SvgGoogleSheetsRegularIcon;
